import React, { Component } from 'react';
import browserStorage from '../../../../common/services/browserStorage';

class AuthorizationRedirect extends Component {
	componentDidMount() {
		const { franchisor, useSandbox, paymentConfigurationId, paymentOwnerType, paymentOwnerId, franchiseeId } = this.props;
		// store required data in local storage and pass the local storage key as GoCardless state param
		const storedData = {
			useSandbox,
			paymentConfigurationId,
			paymentOwnerType,
			paymentOwnerId,
			franchiseeId
		};
		const storedDataKey = Math.random().toString(36).substr(2);
		browserStorage.setToSessionStorage(franchisor, storedDataKey, JSON.stringify(storedData));

		const authorizeUrl = useSandbox ? 'https://connect-sandbox.gocardless.com/oauth/authorize' : 'https://connect.gocardless.com/oauth/authorize';
		const clientId = useSandbox ? franchisor.goCardlessSandboxClientId : franchisor.goCardlessLiveClientId;
		const redirectUrl = franchisor.goCardlessOAuthRedirectUrl;

		window.location = `${authorizeUrl}?client_id=${clientId}` +
			`&redirect_uri=${encodeURIComponent(redirectUrl)}` +
			`&state=${franchisor.id}.${encodeURIComponent(storedDataKey)}` +
			'&initial_view=signup&response_type=code&scope=read_write';
	}

	render() {
		return <div>Redirecting...</div>;
	}
}

export default AuthorizationRedirect;